function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Calendar(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.526 2.75a.75.75 0 01.75.75v3.579a.75.75 0 11-1.5 0v-1.04h-1.04a1.04 1.04 0 00-1.039 1.04v2.829h14.606V7.079a1.04 1.04 0 00-1.04-1.04h-.447a.75.75 0 010-1.5h.447a2.54 2.54 0 012.54 2.54V18.71a2.54 2.54 0 01-2.54 2.539H5.737a2.54 2.54 0 01-2.54-2.54V7.08a2.54 2.54 0 012.54-2.54h1.04V3.5a.75.75 0 01.75-.75zm11.777 8.658H4.697v7.303c0 .574.466 1.039 1.04 1.039h12.526a1.04 1.04 0 001.04-1.04v-7.302zM14.684 2.75a.75.75 0 01.75.75v3.579a.75.75 0 01-1.5 0v-1.04h-3.276a.75.75 0 010-1.5h3.276V3.5a.75.75 0 01.75-.75z",
    clipRule: "evenodd"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Calendar);
export default ForwardRef;